import React from 'react';
import './SearchInterface.css'; // Assuming you might create a separate CSS for SearchInterface

function SearchInterface({ searchQuery, setSearchQuery, onSearch, onToggleAdvancedSearch, isLoading, showAdvancedSearchButton = true }) {
  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
    // Do NOT call onSearch here
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    onSearch(); // Only trigger search on submit (button click or Enter)
  };

  return (
    <div className="search-interface-container">
      <form onSubmit={handleSearchSubmit} className="search-form">
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="សូមបញ្ចូលពាក្យគន្លឹះដើម្បីស្វែងរក......"
            value={searchQuery}
            onChange={handleInputChange}
            className="search-input"
            disabled={isLoading} // Disable input while loading
          />
          <button type="submit" className="search-button" disabled={isLoading}>
            {isLoading ? '...' : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="search-icon">
                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5 1.41-1.41L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
              </svg>
            )}
          </button>
        </div>
        {showAdvancedSearchButton && (
          <button type="button" onClick={onToggleAdvancedSearch} className="advanced-search-button" disabled={isLoading}>
            កំណត់លក្ខខណ្ឌ
          </button>
        )}
      </form>
    </div>
  );
}

export default SearchInterface;

// Inline styles for simplicity, can be moved to SearchInterface.css
const styles = {
  container: {
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    // padding: '20px',
    // backgroundColor: '#F8F5F2', // Warm Off-White - moved to App.css
    // borderBottom: '1px solid #e0d9d2',
    // position: 'sticky', // Sticky position - moved to App.css
    // top: 'HEADER_HEIGHT_PX', // This will be set dynamically or via CSS variable after header height is known
    // zIndex: 999, // Below header but above content
    // boxSizing: 'border-box',
  },
};
